import { render, staticRenderFns } from "./ModalWaiting.vue?vue&type=template&id=70cfcce0&scoped=true"
import script from "./ModalWaiting.vue?vue&type=script&lang=js"
export * from "./ModalWaiting.vue?vue&type=script&lang=js"
import style0 from "./ModalWaiting.vue?vue&type=style&index=0&id=70cfcce0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70cfcce0",
  null
  
)

export default component.exports